export enum EZoutiType {
  GATEWAY = 'GATEWAY',
  ABANDONED_CART = 'ABANDONED_CART',
}
